import styled from 'styled-components'

type ILoadingWrapper = {
  position: string
  iconwidth: string
}

/**
 * Loading should be wrap in a parent element with position: relative to occupy the space
 */
export const LoadingWrapper = styled.div<ILoadingWrapper>`
  position: ${(props) => (props.position ? props.position : 'absolute')};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 100; // high number to be always on top
  background: ${(props) =>
    props.theme.loadingBgColor || 'rgba(255,255,255,0.5)'};

  svg {
    width: ${(props) => (props.iconwidth ? props.iconwidth : '120px')};

    circle {
      stroke: ${({ theme }) => theme.primaryColor || '#1976d2'};
    }
  }
`

export const LoadingContainer = styled.div`
  position: relative;
  min-height: 300px;
`
